// @flow

export const FOLDER_TYPE = 7
export const USERS_ACCESS_ALLOW = 'allow'
export const USERS_ACCESS_DENY = 'deny'
